import ApiService from './api.service';

const ClaimHistory = {
    getAllNotes(parameter) {
        var params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            SeqNo: parameter.SeqNo,
        }

        const requestData = {
            method: 'get',
            url: '/RcmClaimNotesHistory',
            headers: {},
            params: params
        }
        return ApiService.customRequest(requestData);
    },

    getAllNotesDetails(parameter) {
        var params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            SeqNo: parameter.SeqNo,
        }

        const requestData = {
            method: 'get',
            url: '/RcmClaimNotesHistory/details',
            headers: {},
            params: params
        }
        return ApiService.customRequest(requestData);
    },

    getAllARStatusHistory(parameter) {
        var params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            SeqNo: parameter.SeqNo,
        }

        const requestData = {
            method: 'get',
            url: '/ClaimHistories',
            headers: {},
            params: params
        }
        return ApiService.customRequest(requestData);
    },

    getAllARStatusHistoryDetails(parameter) {
        var params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            SeqNo: parameter.SeqNo,
        }

        const requestData = {
            method: 'get',
            url: '/ClaimHistories/details',
            headers: {},
            params: params
        }
        return ApiService.customRequest(requestData);
    },

    addNote(data) {
        return ApiService.post('/RcmClaimNotesHistory', data);
    },

    bulkInsertHistory(data) {
        return ApiService.post('/ClaimHistories/bulk', data);
    },

    bulkInsertNoteHistory(data) {
        return ApiService.post('/RcmClaimNotesHistory/bulk', data);
    }
}

export default ClaimHistory;